import Vue from 'vue'
import {
  ERROR_DEFAULT,
  ERROR_422
} from '@/utils/constants/errors'

export default new Vue({
  data () {
    return {
      // count is used as a vuejs key to transition messages properly
      count: 0
    }
  },
  methods: {
    /**
     * send message to message component
     * @param message text to send
     * @param type message color (success | info | warning | error | vuetify color)
     */
    sendMessage (message: string, type: string) {
      this.$emit('message-sent', message, type, this.count)
      this.count++
    },

    /**
     * send default error message
     */
    sendDefaultError () {
      this.$emit('message-sent', ERROR_DEFAULT, 'error', this.count)
      this.count++
    },

    /**
     * send 422 error message (used for form errors)
     */
    sendFormError () {
      this.$emit('message-sent', ERROR_422, 'error', this.count)
      this.count++
    }

  }

})
